import { render } from "./VideoPlayerRender.vue?vue&type=template&id=0be8f55e&ts=true"
import script from "./VideoPlayerRender.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerRender.vue?vue&type=script&lang=ts"

import "./VideoPlayerRender.vue?vue&type=style&index=0&id=0be8f55e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__